import queryString from 'query-string';

export function getQueryParam(key) {
  const queryParams = window ? queryString.parse(window.location.search) : {};

  return queryParams[key] || null;
}

export function setQueryParam(key, value) {
  if (!window) {
    return;
  }

  const query = { [key]: value };
  const newUrl = queryString.stringifyUrl({ url: window.location.href, query });

  history.replaceState({}, '', newUrl);
}
